import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { motion, AnimatePresence } from "framer-motion";

import "./style.css";
import { toggleConfirmReplaceModal } from "../../../redux/slices/sidebarSliders";
import Close from "../../../assets/icons/back";

export default function SuccessModal({ message, description, secondaryButton, primaryButton, handleClose, hideHeader, hideButtons }) {
  const dispatch = useDispatch();
  const { selectedUserActivity } = useSelector((state) => state.userActivity);


  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.4, type: "tween", ease: "anticipate" }}
        className="modal_container confirm_replace_modal success_modal"
      >
        <motion.div
          initial={{ scale: 0.7 }}
          animate={{ scale: 1 }}
          exit={{ scale: 0.7 }}
          transition={{ duration: 0.4, type: "tween", ease: "anticipate" }}
          className="modal_basic"
          onClick={(e) => e.stopPropagation()}
        >
          {!hideHeader &&
            <div className="menu_header">
              <div className="close_menu_btn" onClick={handleClose}>
                <Close />
              </div>
            </div>
          }

          <div className="modal_basic_content">
            <p className="success_message">
              {message}
            </p>
            <p className="description">
              {description}
            </p>
            {
              !hideButtons &&
              <div className="buttons">
                <button className="btn secondary-btn" onClick={secondaryButton.onClick} >
                  {secondaryButton.text}
                </button>
                <button className="btn btn-primary" onClick={primaryButton.onClick}>
                  {primaryButton.text}
                </button>
              </div>
            }

          </div>

        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
}
